import { CgGym } from "react-icons/cg";
import { LuCrown } from "react-icons/lu";
import { GiStrongMan } from "react-icons/gi";

const Data = [
    {
        id: 1,
        imgIcon: <CgGym />,
        title: "BASIC PLAN",
        price: "$20",
        description1: "2 hours of exercise",
        description2: "Basic Nutrition Guidance",
        description3: "Access to The Community",
        description4: "Starter Kit",
        button: "Join Now " 
    },
    {
        id: 1,
        imgIcon: <LuCrown />,
        title: "PREMIUM PLAN",
        price: "$30",
        description1: "5 hours of exercise",
        description2: "Free consultation to coaches",
        description3: "Advanced Progress Metrics",
        description4: "Personalized Nutrition ",
        button: "Join Now " 
    },
    {
        id: 1,
        imgIcon: <GiStrongMan />,
        title: "PRO PLAN",
        price: "$45",
        description1: "8 hours of exercise",
        description2: "Free consultation to coaches",
        description3: "Discounts on Merchandise",
        description4: "Elite Community Membership",
        button: "Join Now " 
    }
]

export default Data;